var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"modals-container"}},_vm._l((_vm.modals),function(modal){return _c(modal.component,_vm._g(_vm._b({key:modal.id,tag:"component",on:{"close":function($event){return _vm.onClose(modal.id)}}},'component',modal.props,false),modal.on))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }